export default __webpack_public_path__ + "1c89368bf14ba37ca2c40fce6000aef2.png";